<template>
  <el-dialog
    :visible="show"
    :data="tableData"
    @update:visible="updateVisiable($event)"
    :title="title"
    :top="top"
    :width="width"
    show-close
    class="dialog_user"
    @open="$emit('open')"
    @opened="onOpened"
    @close="$emit('close')"
    @closed="$emit('closed')"
  >
    <el-table class="playback" style="width: 100%;margin-top: 20px"  :header-cell-style="setHeraderStyle" :data="tableData" v-loading="loading">
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :width="item.width"
        :label="item.title"
        :prop="item.key"

      >
        <template #default="{row}" v-if="item.key == 'action'">
<!--          <el-button-->
<!--            type="primary"-->
<!--            size="mini"-->
<!--            style="width: 56px;height: 26px;background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none;outline: none"-->
<!--            @click="handleWatch(row)"-->
<!--          >{{language.watch}}</el-button>-->

          <!--查看-->
          <el-button
              size="mini"
              v-if="choose == 'playback'"
              style="width: 65px;height: 30px;background: #0071FF;border: none;outline: none;font-size: 16px;color: #FFFFFF;border-radius: 5px;"
              @click="handleWatch(row)"
          >{{language.watch}}</el-button>

          <!--查看简历-->
          <el-button
              size="mini"
              v-if="choose == 'interviewee'"
              style="height: 30px;background: #f47900;border: none;outline: none;font-size: 16px;color: #FFFFFF;border-radius: 5px;"
              @click="handleWatch(row)"
          >{{language.watchjl}}</el-button>

          <!--填写备注-->
          <el-button
              size="mini"
              v-if="choose == 'interviewee'"
              style="height: 30px;background: #005bcd;border: none;outline: none;font-size: 16px;color: #FFFFFF;border-radius: 5px;"
              @click="handleWatch(row)"
          >{{language.fillNote}}</el-button>

        </template>
      </el-table-column>
      <template slot="empty">
        {{search_condition.empty}}
      </template>

    </el-table>

    <pagination
      v-show="search_condition.total > 0"
      style="margin-top: 10px"
      :total="search_condition.total"
      :page.sync="search_condition.currentPage"
      :limit.sync="search_condition.pageSize"
      :pagerCount="pagerCount"
      @pagination="getPagination"
      :class=" inter_page ? 'inter-playback' : 'page-playback'"
    />
<!--插槽-->
    <slot/>
    <!-- <el-button style="margin-top: 20px;" v-if="linkButton" @click="gotoHref">{{lan=='ch'?'导出列表':'Export list'}}</el-button> -->
  </el-dialog>
</template>

<script>
  import {getLiveUser, callbackPlay, LiveRoomLineHistory, LiveRoomPrivateTalk} from "../../api/forum";
  import {mapGetters} from "vuex";
  import pagination from "../../components/Pagination/pagination";
  import {stateEnum} from "../../pages/user/attendancerecord/enum";
  import {isEmpty} from "../../common/validate"
  import {SubscribeCz} from "../../api/btManage";
  import Cookie from "../../common/cookie";

  const default_condition = {
    empty: "",
    total: 0,
    currentPage: 1,
    pageSize: 6,
  }
  export default {
    components: {
      pagination
    },
    computed: {
      ...mapGetters(["token"]),
    },
    props: {
     top: {
        type: String,
        default: "20vh"
      },
     show: {
       type: Boolean,
       default: false
     },
    linkButton: {
      type: Boolean,
      default: false
    },
    gotoLink: {
      type: String,
      default: ""
    },
     title: {
       type: String,
       default: ""
     },
      //表头
     columns: {
       type: Array,
       default: () => []
     },
     width: {
       type: String,
       default: "540px"
     },
     language: {
       type: Object,
       default: () => {}
     },
     initCont: { //初始化内容
       type: Object,
       default: () => {}
     },
      //类型
     fn: {
       type: Number,
       default: 0
     },
      //回放和面试人员列表
      choose: {
        type:String,
        default:""
      },
      inter_page:{
       type:Boolean,
        default:false
      }
   },
    data() {
      const search_condition = Object.assign(
        {},
        default_condition
      );
      return {
        pagerCount:2,
        loading: true,
        tableData: [],
        search_condition,
        stateEnum,
        lan: Cookie.get("lang"),
      }
    },
    watch: {
      show() {
        if (!this.show) {
          this.search_condition = Object.assign(
            {},
            default_condition
          );
          this.tableData = []
        }
      }
    },
    methods: {
      gotoHref(){
        window.location.href = this.gotoLink;
      },
      updateVisiable(v) {
        this.$emit("update:show", v)
      },
      handleWatch(row){
        this.$emit("select-cz-info", row, this.initCont, this.fn);
      },
      loadData() {
        this.loading = true;
        const props = {
          token: this.token,
          roomid: this.initCont.broadcast_id,
          currentPage: this.search_condition.currentPage,
          numberPage: this.search_condition.pageSize
        };
        console.log("fn====  " + this.fn);
        if (this.fn == this.stateEnum.COMPANY_LIST) {
          //洽谈公司列表
          getLiveUser(props).then(res => {
            if (res.type != "1") {
              if (this.lan == "ch"){
                this.search_condition.empty = res.text;
                this.loading = false;
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.search_condition.empty = res.text_en;
                this.loading = false;
                this.$message.error({message: res.text_en, offset: 120})
              }
              return;
            }
            if (isEmpty(res.data)) {
              this.search_condition.empty = "";
              this.search_condition.total = 0;
              this.tableData =[];
              this.loading = false;
              return
            }
            res.data.forEach(item=>{
              if (this.lan=="en") {
                item.company=item.company_en||item.company
                item.turename=item.turename_en||item.turename
              }else{
                item.company=item.company||item.company_en
                item.turename=item.turename||item.turename_en
              }
            })
            this.search_condition.empty = "";
            this.search_condition.total = res.datacount;
            this.tableData = res.data;
            this.loading = false;
          });
          return;
        }
        //查看预约
        if (this.fn == this.stateEnum.SEEAPPOINTMENT){
          let props = {
            token: this.token,
            broadcast_id: this.initCont.broadcast_id,
            currentPage: this.search_condition.currentPage,
            numberPage: this.search_condition.pageSize
          }
          SubscribeCz(props).then(res => {
            if (res.type != "1") {
              if (this.lan == "ch"){
                this.search_condition.empty = res.text;
                this.loading = false;
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.search_condition.empty = res.text_en;
                this.loading = false;
                this.$message.error({message: res.text_en, offset: 120})
              }
              return;
            }
            if (isEmpty(res.data)) {
              this.search_condition.empty = "";
              this.search_condition.total = 0;
              this.tableData =[];
              this.loading = false;
              return
            }
            this.search_condition.empty = "";
            this.search_condition.total = res.datacount;
            this.tableData = res.data;
            this.loading = false;
          })
          return;
        }
        //查看线下预约
        if (this.fn == this.stateEnum.OFFLINEAPPOINTMENTS){
          let props = {
            token: this.token,
            room_id: this.initCont.broadcast_id,
            currentPage: this.search_condition.currentPage,
            numberPage: this.search_condition.pageSize
          }
          LiveRoomPrivateTalk(props).then(res => {
            if (res.type != "1") {
              if (this.lan == "ch"){
                this.search_condition.empty = res.text;
                this.loading = false;
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.search_condition.empty = res.text_en;
                this.loading = false;
                this.$message.error({message: res.text_en, offset: 120})
              }
              return;
            }
            if (isEmpty(res.data)) {
              this.search_condition.empty = "";
              this.search_condition.total = 0;
              this.tableData =[];
              this.loading = false;
              return
            }
            this.search_condition.empty = "";
            this.search_condition.total = res.datacount;
            this.tableData = res.data;
            this.loading = false;
          })
          return;
        }
        if(this.fn == this.stateEnum.LINEHISTORY){

          const params = {
            token: this.token,
            room_id: this.initCont.broadcast_id,
            currentPage: this.search_condition.currentPage,
            numberPage: this.search_condition.pageSize
          };
          LiveRoomLineHistory(params).then(res=>{
            if (res.type != "1") {
              if (this.lan == "ch"){
                this.search_condition.empty = res.text;
                this.loading = false;
                this.$message.error({message: res.text, offset: 120})
              }else {
                this.search_condition.empty = res.text_en;
                this.loading = false;
                this.$message.error({message: res.text_en, offset: 120})
              }
              return;
            }
            if (isEmpty(res.data)) {
              this.search_condition.empty = "";
              this.search_condition.total = 0;
              this.tableData =[];
              this.loading = false;
              return
            }
            this.search_condition.empty = "";
            this.search_condition.total = res.datacount * 1;
            this.tableData = res.data;
            this.loading = false;
          })
          return;
        }
        //回放
        callbackPlay(props).then(res => {
          if (res.type != "1") {
            if (this.lan == "ch"){
              this.search_condition.empty = res.text;
              this.loading = false;
              this.$message.error({message: res.text, offset: 120})
            }else {
              this.search_condition.empty = res.text_en;
              this.loading = false;
              this.$message.error({message: res.text_en, offset: 120})
            }
            return
          }
          const data = res.data;
          if (!isEmpty(data)) {
            data.forEach(item => {
              item.time = `${item.begtruetime} - ${item.endtruetime}`
            });
            this.search_condition.total = res.datacount;
            this.tableData = res.data;
          }else {
            this.search_condition.total = res.datacount;
            this.tableData = [];
          }
          this.search_condition.empty = "";
          this.loading = false;
        })


      },
      getPagination(val) {
        this.search_condition.currentPage=val.page;
        this.loadData();
      },
      onOpened() {
        this.$emit("opened");
        this.loadData();
      },
      setHeraderStyle({ rowIndex }) {
        if (rowIndex === 0) {
          return `background-color: #F2F2F2;
                        color: #424242;
                        padding:7.5px 0;
                        font-size:14px;
                        border-top: 1px solid #e6e6e6 ;
                        border-bottom: 1px solid #e6e6e6 ;
                        font-weight: normal;
                        `;
        }
      }
    },
  }
</script>

<style scoped>

  /* .dialog_user >>> .pagination-wrap{
    background: #fff;
    color: ;
  } */
  .playback >>> .has-gutter th {
    background: #f6f9ff !important;
  }
  .playback >>> .has-gutter th div {
     font-size: 16px;
    margin: auto 0;
  }
  .dialog_user >>> .btn-prev{
    background: #FFFFFF !important;
    color: #0c6dce !important;
  }
   .dialog_user >>> .btn-next{
    background: #FFFFFF !important;
    color: #0c6dce !important;
  }
   .dialog_user >>> .el-pager li{
    background: rgb(242, 242, 242);
    color: #0c6dce;
  }
  .dialog_user >>> .el-pagination__jump{
    color: #333333 !important;
  }

</style>

<style>
.page-playback,
.inter-playback{
  text-align: center;
}
.page-playback .el-pagination {
  margin-left: -6px;
}
.page-playback .el-pagination.is-background .el-pager li:not(.disabled).active,
.inter-playback .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #0071FF;
  height: 27px;
  line-height: 27px;
  color: #FFFFFF;
}
.page-playback .el-pagination.is-background .el-pager li,
.inter-playback .el-pagination.is-background .el-pager li{
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  color: #333333;
}
.page-playback .tiaozhuan {
  /*position: relative;*/
  /*left: 37px;*/
  margin-left: 5px;
}
.inter-playback .tiaozhuan{
  margin-left: 66px;
}
.page-playback .el-pagination__jump,
.inter-playback .el-pagination__jump{
  margin-left: 5px;
}
  .dialog_user .el-dialog {
    padding: 20px
  }
.dialog_user .el-dialog__header {
  padding: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #a1a1a1;
}
  .dialog_user .el-dialog__title {
    font-size: 14px;
    line-height: 14px;
  }
  .dialog_user .el-dialog__body {
    padding: 0;
    padding-bottom: 40px;
  }
  .dialog_user .el-table .cell {
    padding-left: 20px;
  }
   .el-table th>.cell {
    border-right: 1px solid #cccccc;
    height: 18px;
    line-height: 18px;
    padding-left: 20px;
  }
  .has-gutter th:nth-last-child(2) .cell{
    border-right: 0;
  }

</style>
